export const handleSinglePacksTransition = (aggregation, setSelectedFlavors, handleTransitionFromSubscriptionToSinglePacks) => {
    setSelectedFlavors({});
    const lastSingleProductSku = aggregation?.onetime?.single_packs?.sku;
    handleTransitionFromSubscriptionToSinglePacks(lastSingleProductSku);
};
//# sourceMappingURL=handleSinglePacksTransition.js.map